import { useCallback, useEffect, useState } from 'react';
import { getUnreadCount, getPendingTasksCount } from '../api/notificationApi';

export function useNotifications(pollInterval = 30000) {
    const [unreadCount, setUnreadCount] = useState(0);
    const [pendingTaskCount, setPendingTaskCount] = useState(0);

    const fetchCount = useCallback(async () => {
        try {
            const [unreadRes, taskRes] = await Promise.all([
                getUnreadCount(),
                getPendingTasksCount()
            ]);
            setUnreadCount(unreadRes.data);
            setPendingTaskCount(taskRes.data);
        } catch {
            // silently ignore
        }
    }, []);

    useEffect(() => {
        fetchCount();
        const interval = setInterval(fetchCount, pollInterval);
        return () => clearInterval(interval);
    }, [fetchCount, pollInterval]);

    return { unreadCount, pendingTaskCount, refreshCount: fetchCount };
}
